import styled from 'styled-components'

export const TitleWrapper = styled.div`
  ${({ theme }) => `
    padding-top: ${theme.space.mobile.small};
    color: ${theme.color.ocean};
    font-weight: ${theme.fontWeight.bold};
  `}
`
